

(function () {
	const SECTION = ".information-bar-section";
	const LINK = ".information-bar__link";
	const STYLE_ID = "ib-css-rotate";

	/* ============================================================
	   CSS-РОТАЦІЯ ЗАМІСТЬ SWIPER — 10.09.2026

	   Раніше ця панель на мобільних (< 751px) ініціалізувала повний
	   Swiper з loop і autoplay. Заміри PageSpeed 10.09: swiper-bundle.min.js
	   коштував 1 847-2 869 мс основного потоку на головній (проти 70 мс на
	   картці товару), і LCP-зображення, завантажене вже на 0,3-0,6 с, не
	   могло відмалюватись ще ~2 с. LCP головної був 12,9-13,1 с проти
	   3,6-4,4 с на колекції та картці, де цієї панелі немає.

	   Тепер ротація повністю на CSS: JS лише один раз збирає правила і
	   вставляє <style>. Swiper для цих панелей не викликається взагалі.

	   Чому не буде зсуву розмітки: всі посилання лежать в ОДНІЙ комірці
	   grid, тож висота коробки дорівнює найвищому з них і задана з першого
	   показу. Нічого не з'являється і не зникає з потоку — змінюються лише
	   opacity і visibility.

	   Клікабельним є тільки видиме посилання: visibility анімується разом
	   з opacity, а visibility:hidden не приймає вказівник. Без цього натиск
	   потрапляв би на останнє посилання в DOM.

	   Секцій на сторінці може бути кілька з різною кількістю посилань
	   (на головній 10.09 їх дві: 4 і 3). Тому правила генеруються окремо
	   для кожної кількості, а секція позначається data-ib-css="<кількість>".

	   Десктоп не змінюється: .information-bar__wrapper з display:flex і
	   flex-wrap:wrap живе в @media (min-width: 750px), а вся ротація —
	   в @media (max-width: 750px).
	   ============================================================ */

	/* Секунд на одне посилання і тривалість згасання. */
	const SLIDE_SECONDS = 3.5;
	const FADE_SECONDS = 0.35;

	const buildCssFor = (count) => {
		const total = count * SLIDE_SECONDS;
		const pct = (seconds) => Math.round((seconds / total) * 10000) / 100;
		const name = "ibRotate" + count;
		const scope = '[data-ib-css="' + count + '"] ';

		let delays = "";
		for (let i = 0; i < count; i += 1) {
			delays +=
				scope + LINK + ":nth-child(" + (i + 1) + ")" +
				"{animation-delay:" + (i * SLIDE_SECONDS) + "s;}";
		}

		return (
			"@keyframes " + name + "{" +
			"0%{opacity:0;visibility:visible;}" +
			pct(FADE_SECONDS) + "%{opacity:1;visibility:visible;}" +
			pct(SLIDE_SECONDS - FADE_SECONDS) + "%{opacity:1;visibility:visible;}" +
			pct(SLIDE_SECONDS) + "%{opacity:0;visibility:hidden;}" +
			"100%{opacity:0;visibility:hidden;}" +
			"}" +

			"@media screen and (max-width:750px){" +
			scope + ".information-bar__wrapper{" +
			"display:grid !important;grid-template-areas:'ibslide';" +
			"grid-template-columns:100%;align-items:center;height:auto !important;}" +

			scope + LINK + "{" +
			"grid-area:ibslide;width:100% !important;height:auto !important;" +
			"opacity:0;visibility:hidden;" +
			"animation-name:" + name + ";animation-duration:" + total + "s;" +
			"animation-iteration-count:infinite;animation-timing-function:linear;}" +

			delays +
			"}" +

			"@media screen and (max-width:750px) and (prefers-reduced-motion:reduce){" +
			scope + LINK + "{animation:none;opacity:0;visibility:hidden;}" +
			scope + LINK + ":first-child{opacity:1;visibility:visible;}" +
			"}"
		);
	};

	const apply = () => {
		const sections = document.querySelectorAll(SECTION);
		if (!sections.length) return;

		const counts = [];

		sections.forEach((section) => {
			const count = section.querySelectorAll(LINK).length;

			/* Менше двох посилань — крутити нічого. */
			if (count < 2) {
				section.removeAttribute("data-ib-css");
				return;
			}

			section.setAttribute("data-ib-css", String(count));
			if (counts.indexOf(count) === -1) counts.push(count);
		});

		if (!counts.length) return;

		let style = document.getElementById(STYLE_ID);
		if (!style) {
			style = document.createElement("style");
			style.id = STYLE_ID;
			document.head.appendChild(style);
		}

		const css = counts.map(buildCssFor).join("");
		if (style.textContent !== css) style.textContent = css;
	};

	apply();

	/* Редактор теми перебудовує секцію — застосовуємо знову. */
	document.addEventListener("shopify:section:load", apply);
})();